import classes from "./contactToggleSection.module.scss";

const ContactToggleSection = ({ label, checked, onChange, children, variant = "card" }) => (
  <div className={`${classes.root} ${variant === "embedded" ? classes.embedded : ""}`}>
    <div className={classes.header}>
      <button
        type="button"
        className={`${classes.switch} ${checked ? classes.switchOn : ""}`}
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
      >
        <span className={classes.switchThumb} aria-hidden="true" />
      </button>
      <span className={classes.label}>{label}</span>
    </div>
    {checked && children ? <div className={classes.body}>{children}</div> : null}
  </div>
);

export default ContactToggleSection;
